import AboutServices from './AboutServices.vue';

export { AboutServices };
export default AboutServices;
